import Barcode from "react-jsbarcode";

const GeneratBarcode = ({ value }) => {
  /*  const { inputRef } = useBarcode({
    value,
    options: {
      height: 30,
      fontSize: 16,
    },
  }); */
  /* 
  return <svg ref={inputRef} />; */
  return (
    <Barcode
      value={value}
      options={{
        height: 30,
        fontSize: 16,
      }}
    />
  );
};
/* m djc */

export default GeneratBarcode;
